import type { Tracker } from '../../types';
import {
    awaitAdvertisingPixels,
    createMissingPixelWarning,
} from '../advertising-pixels';
import { getOutbrainEvent } from './utils';

declare function obApi(
    command: 'track',
    eventName: string,
    // data?: Record<string, unknown>
): void;

export function createOutbrainTracker(): Tracker {
    const warnPixelMissing = createMissingPixelWarning('Outbrain');

    return {
        name: 'outbrainTracker',
        async log(event, opts) {
            await awaitAdvertisingPixels();

            const outbrainEventData = getOutbrainEvent(event);
            if (!outbrainEventData) return;

            const { eventName } = outbrainEventData;

            if (typeof obApi === 'undefined') {
                warnPixelMissing(eventName);
                return;
            }

            console.log(
                '%cOutbrainEvent: ' +
                    eventName +
                    ' ' +
                    JSON.stringify(opts.data),
                'background: #222; color: #bada55',
            );

            // Not clear today if params are supported by Outbrain yet. We will revisit this if needed.
            // if (opts.data) {
            //     obApi('track', eventName, opts.data);
            // }

            obApi('track', eventName);
        },
        release() {
            // do nothing
        },
    };
}
